import React from 'react';
import { List } from 'semantic-ui-react'
// import {graphql} from 'react-apollo';

//utils
// import queries from '../../../src/utils/queries'

import TitDer from '../../../components/funcionales/titder';

// import EstilosHome from '../../css/home.css';

//Ofertas
const DetalleNivel1 = ({styles, elemento, handleClickidLista}) => {
  return(
    <tr className=''  onClick={(ev)=>handleClickidLista(ev, elemento)}>
      <td className=''>{elemento.codigoOferta}</td>
      <td className=''>{elemento.descrOferta}</td>
      <td className='' style={{color: elemento.estadoOferta?'yellow':'#93291E', fontWeight: 'bold'}}>{elemento.estadoOferta?'ACTIVA':'INACTIVA'}</td>

    </tr>
  )
};

const Lista = ({styles, list, handleClickidLista}) => {
  const nivel1Detalle = list.map((elemento, _id) => <DetalleNivel1 elemento={elemento} styles={styles}
    handleClickidLista={handleClickidLista} key={elemento._id}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

const ConfOfer2 = ({autorizacUA, styles, handleClick, list, handleClickidLista}) => {
  const a251501 = autorizacUA.findIndex( autorizac => autorizac === "251501" );

    return (
    <div>
      <List selection>
        <TitDer list={list} textBoton1="Ofertas" btnNuevo={a251501!==-1?"SI":"NO"} styles={styles} handleClick={handleClick} />
        <div>
          <table className='ui blue inverted celled selectable table' style={styles.styTableSup}>
            <thead className=''>
              <tr className=''>
                <th className='' style={{width: '20%'}}>Código</th>
                <th className='' style={{width: '60%'}}>Descripción</th>
                <th className='' style={{width: '20%'}}>Estado</th>
              </tr>
            </thead>
            <Lista styles={styles} list={list} handleClickidLista={handleClickidLista}/>
          </table>
          <p></p>
        </div>
      </List> 
    </div>
  )
};

export default ConfOfer2
